"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
class AnomalyModel extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'anomalyModel';
        this._behaviourType = initParams.behaviour_type;
        this._status = initParams.status;
        this._deviceId = initParams.device_id;
        this._created = initParams.created;
        this._trained = initParams.trained;
        this._trainingResults = initParams.training_results;
        this._startTs = initParams.start_ts;
        this._endTs = initParams.end_ts;
    }
    set behaviourType(value) {
        console.error('Do not set objects this way');
    }
    get behaviourType() {
        return this._behaviourType;
    }
    set status(value) {
        console.error('Do not set objects this way');
    }
    get status() {
        return this._status;
    }
    set deviceId(value) {
        console.error('Do not set objects this way');
    }
    get deviceId() {
        return this._deviceId;
    }
    set created(value) {
        console.error('Do not set objects this way');
    }
    get created() {
        return this._created;
    }
    set trained(value) {
        console.error('Do not set objects this way');
    }
    get trained() {
        return this._trained;
    }
    set trainingResults(value) {
        console.error('Do not set objects this way');
    }
    get trainingResults() {
        return this._trainingResults;
    }
    set startTs(value) {
        console.error('Do not set objects this way');
    }
    get startTs() {
        return this._startTs;
    }
    set endTs(value) {
        console.error('Do not set objects this way');
    }
    get endTs() {
        return this._endTs;
    }
}
exports.default = AnomalyModel;
//# sourceMappingURL=anomalyModel.js.map